<template>
	<div class="main">
		<div class="leftSidebar">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/' }">{{$t('nav.home')}}</el-breadcrumb-item>
			  <el-breadcrumb-item>{{$t('nav.about')}}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="title">{{$t('indexs.aouts')}}</div>
			<div class="left_nav">
				<router-link :to="{name:'synopsis'}" :class="$route.name=='synopsis'?'link active':'link'"><span></span>{{$t('about.abCen')}}</router-link>
				<router-link :to="{name:'expert'}" :class="$route.name=='expert'?'link active':'link'"><span></span>{{$t('about.zhjia')}}</router-link>
				<router-link :to="{name:'quality'}" :class="$route.name=='quality'?'link active':'link'"><span></span>{{$t('about.zhl')}}</router-link>
				<router-link :to="{name:'culture'}" :class="$route.name=='culture'?'link active':'link'"><span></span>{{$t('about.qiwen')}}</router-link>
			</div>
		</div> 
		<div class="container1">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		mounted() {
		},
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.main {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;

		.leftSidebar {
			width: 255px;
			min-height: 900px;
			// overflow: auto;
			.el-breadcrumb{
				width: 255px;
				height: 96px;
				display: flex;
				align-items: center;
			}
			.title{
				width: 260px;
				// height: 60px;
				height: 70px;
				padding: 12px;
				background: #E5EBF5;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 24px;
				font-weight: bold;
				color: #004098;
			}
			.left_nav{
				width: 260px;
				.title{
					height: 44px;
					display: flex;
					align-items: center;
					border-left: 10px solid #666666;
					font-size: 18px;
					color: #010101;
					padding-left: 40px;
				}
				.link{
					width: 260px;
					height: 60px;
					background: #E5EBF5;
					display: flex;
					align-items: center;
					// padding-left: 60px;
					padding-left: 40px;
					font-size: 16px;
					color: #004098;
					cursor: pointer;
					span{
						width: 20px;
						height: 20px;
						display: block;
						border: 6px solid #004098;
						border-radius: 50%;
						margin-right: 10px;
					}
				}
				.active,.link:hover{
					background:#004098;
					color: #fff;
					span{
						border-color: #fff;
					}
				}
			}
		}

		.leftSidebar::-webkit-scrollbar {
			display: none;
		}
		.container1 {
			margin: 96px 0;
			// width: 900px;
			// width: 800px;
			background-color: #fff;
			// overflow: auto;
		}
		.container1::-webkit-scrollbar {
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/AboutUs.vue